var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"icon":"el-icon-printer","disabled":_vm.disabled || _vm.printing,"loading":_vm.printing},on:{"click":_vm.print}},[_vm._v("打印审批单")])}
var staticRenderFns = []

export { render, staticRenderFns }